<ng-container *ngIf="!isFenceCalculation()">
  <mat-radio-group [(ngModel)]="minimumAccessories" (change)="recalculateAccessories()" aria-label="Selecteaza o optiune">
    <mat-card appearance="outlined" class="card-radius radio-container">
      <mat-card-header>
        <mat-card-title>
          Ce să includem în ofertă?
        </mat-card-title>
        <mat-card-subtitle>
          <em>Îți calculăm automat necesarul, cantitățile se pot modifica.</em>
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div class="radio-content">
          <mat-radio-button color="primary" [value]="false">
            <span>Sistem complet</span>
            <span class="additional-info"> - Recomandat pentru funcționarea optimă a acoperișului</span>
          </mat-radio-button>
        </div>
        <div class="radio-content">
          <mat-radio-button color="primary" [value]="true">
            <span>Minimul necesar</span>
            <span class="additional-info"> - Includem în oferta doar strictul necesar pentru montarea acoperișului</span>
          </mat-radio-button>
        </div>
      </mat-card-content>
    </mat-card>
  </mat-radio-group>
</ng-container>
<form [formGroup]="accessoriesFormGroup">

  <table id="invoice" mat-table [dataSource]="accessories">
    <ng-container matColumnDef="label">
      <th mat-header-cell *matHeaderCellDef>Produs</th>
      <td mat-cell class="product-name" [ngClass]="{'no-border': i === accessories.length - 1}" *matCellDef="let element let i = index">
        <ng-container *ngLet="getAccessoryImage(element.id) as imageUrl">
          <img style="float:left" loading="lazy" *ngIf="imageUrl" [src]="imageUrl" />
        </ng-container>
        {{element.label}} {{element.alias ? '('+ element.alias + ')' : ''}}
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <!-- Quantity Column -->
    <ng-container matColumnDef="quantity">
      <th mat-header-cell *matHeaderCellDef>Cantitate</th>
      <td mat-cell [ngClass]="{'no-border': i === accessories.length - 1}" *matCellDef="let element let i = index">
        <mat-form-field appearance="fill" subscriptSizing="dynamic">
          <input matInput step="1" min="0" type="number" [formControlName]="element.id" [value]="element.quantity"
                 (blur)="changeAccessory(element)">
          <span matSuffix>buc.</span>
        </mat-form-field>
      </td>
    </ng-container>

    <!-- Cost Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell [ngClass]="{'no-border': i === element.length - 1}" *matCellDef="let element let i = index">
        <button mat-button aria-label="Șterge" (click)="removeAccessory(element)" gaEvent="accessory_delete"
                gaCategory="buttons_tracking">
          Șterge
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <div *ngIf="displayRainSystemForm">
    <rain-system-customizations [predefinedProducer]="true" (eventEmitter)="setRainSystemCustomizations($event)"></rain-system-customizations>
  </div>
  <h3 *ngIf="!isManualCalculation()">Dacă dorești și alte acesorii se pot adăuga din lista de mai jos:</h3>
  <h3 *ngIf="isManualCalculation()">👉 Alege din lista de mai jos acesoriile:</h3>
  <div class="row">
    <mat-form-field appearance="fill" id="accessoryField">
      <mat-label>Accesoriu</mat-label>
      <input #accessoriesInput type="text" matInput [formControl]="autocompleteFormControl" [matAutocomplete]="accessoriesAutocomplete">
      <mat-autocomplete #accessoriesAutocomplete="matAutocomplete" [displayWith]="displayAccessoryName" (optionSelected)="selectOption($event)">
        <mat-option *ngFor="let option of (filteredOptions|async)" [value]="option" (click)="addAccessory()" gaEvent="accessory_add"
                    gaCategory="buttons_tracking">
          <img height="30" width="30" loading="lazy" *ngIf="option.imageUrl" [src]="imageBaseUrl+option.imageUrl" />
          <span *ngIf="!option.imageUrl" style="width: 30px; height:30px; display: inline-block;"></span>
          {{productTypeMap[option.category]}} > {{option.name}} {{option.alias ? '('+ option.alias + ')' : ''}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <h3 *ngIf="!hasProductsSelected()" style="color: red;">⚠️️Nu ai selectat nici un produs. Adaugă ori coli de tablă ori accesorii pentru a continua.</h3>
  <step-navigation (forwardClickEmitter)="addToCart()" [disabled]="!hasProductsSelected()"></step-navigation>
</form>
